<template>
  <div class="date-field">
    <b-field>
      <b-datepicker
        mobile-native
        :placeholder="placeholder"
        :min-date="minDate"
        :max-date="maxDate"
        :month-names="arrMonths"
        :day-names="arrDays"
        :date-formatter="dateFormatter"
        @input="handleChange"
        :value="value"
      >
      <span class="note-calendar" v-if="isVisibleNote">{{$t('driver_onboarding.profile.general.note')}}</span>
      </b-datepicker>
      <span class="label--date_field">{{labelName}}</span>
      <img src="/img/icons/calendar.svg" alt="">
    </b-field>
  </div>
</template>
<script>
export default {
  data() {
    return {
      arrMonths: this.$constants.TIME.MONTHS,
      arrDays: this.$constants.TIME.DAYS,
    };
  },
  props: {
    placeholder: {
      type: String
    },
    minDate: {
      type: Date
    },
    maxDate: {
      type: Date
    },
    value: {
      type: Date,
    },
    labelName: {
      type: String
    },
    dateFormatter: {
      type: Function,
      default: function (date) {
        return date && date.toLocaleDateString('vi-VN')
      }  
    },
    isVisibleNote : {
      type : Boolean,
      default : false
    }
  },
  methods: {
    handleChange(value) {
      this.$emit("onChange", value);
    }    
  }
};
</script>
<style lang="scss">
.date-field {
  position: relative;
  img{
    position: absolute;
    right: 0;
    padding: 11px;
    align-items: center;
    z-index: 10;
  }
  .note-calendar {
    font-size: 14px;
    color: #FF3B30;
  }
  .datepicker {
    width: 100%;

    input {
      height: 46px;
      background-color: #f2f2f2;
      outline: none;
      border: none;
      font-size: 14px;
      padding: 12px 0 0 12px;
      border-top-right-radius: 4px !important;
      border-bottom-right-radius: 4px !important;
    }
  }

  .label--date_field {
    position: absolute;
    font-size: 10px;
    color: #7a8189;
    padding: 3px 12px;
    z-index: 5;
  }
}
</style>